import React from 'react'
import TimeIcon from '../Assets/Icons/clockIcon.svg'

export default function AiSuccessProjectCard (props) {
    return(
        <div className='w-full border-[1px] rounded-[12px] border-[#E5E7EB] py-4 px-4 bg-white'>
            <div className='flex items-start justify-between'>
                <div className='flex items-center gap-2'>
                    <img src={props.projectimg} />
                    <div className='flex flex-col gap-[1px]'>
                        <p className='text-[1.2rem] font-[500] text-[#111928]'>{props.projecttitle}</p>
                        <p className='text-[1rem] text-[#6B7280]'>{props.location}</p>
                    </div>
                </div>
                <div className='px-3 py-1 w-fit rounded-[6px] bg-[#F3F4F6] flex items-center gap-2'>
                    <img src={TimeIcon} />
                    <p className='text-[0.94rem] text-[#111928] font-500'>Due in <span>{props.duetime}</span></p>
                </div>
            </div>
                <p className='text-[0.94rem] text-[#6B7280] mt-3'>{props.desc}</p>
        </div>
    );
}